// src/firebase.js
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyD_c_vY91Pn1rE6xV70f50Z2JISIBQLUTM",
    authDomain: "beasts-of-legend-bc9bd.firebaseapp.com",
    projectId: "beasts-of-legend-bc9bd",
    storageBucket: "beasts-of-legend-bc9bd.firebasestorage.app",
    messagingSenderId: "107579008091",
    appId: "1:107579008091:web:67ba13c0ecf4a55a704b7e",
    measurementId: "G-FGET94NQP6"
};

// Always use ONE app instance everywhere.
const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

// Auth
const auth = getAuth(app);
// Persist login (so tokens are available on reload)
setPersistence(auth, browserLocalPersistence).catch(() => { });

// Firestore
const db = getFirestore(app);

// ⚠️ Set this region to where you deployed resolveBattle (default is "us-central1")
const functions = getFunctions(app, 'us-central1');

// If you use the emulator locally, uncomment and ensure regions match:
// import { connectFunctionsEmulator } from 'firebase/functions';
// connectFunctionsEmulator(functions, 'localhost', 5001);

export { app, auth, db, functions };
